import Gradient from '../lib/stripe-gradient/Gradient';

export default class Page {
	constructor() {
		this.w = window.innerWidth
		this.h = window.innerHeight
		this.winScrollTop = window.scrollY;

		this.pageID = document.getElementsByTagName('body')[0].getAttribute('id');
		this.header = document.getElementById("header");
		this.footer = document.getElementById("footer");

		this.loadCommon();
		this.resizeCommon();
		this.scrollCommon();
	}
	loadCommon(){

		var scrollArr = document.querySelectorAll(".scroll");
		//console.log(scrollArr);

		for (var i = 0; i < scrollArr.length; i++) {
			var scrollBtn = scrollArr[i];
			//console.log(scrollBtn);



/*
			scrollBtn.addEventListener('click', (event) => {
				console.log(scrollBtn);
				console.log(event);
				
				
				var href = this.href;
				console.log(href);
				
				event.stopPropagation();
				event.preventDefault();
	
			}, false);
*/


			scrollBtn.addEventListener('click', function(e){
				var href = this.dataset.url;
				//console.log(href);
				
				var linkTarget = document.getElementById(href);
				var linkPos = parseInt(linkTarget.getBoundingClientRect().top) + window.scrollY - 200;
				//console.log(linkPos);
				
				scrollTo({top: linkPos, behavior: 'smooth'});
				
				e.stopPropagation();
				e.preventDefault();
			});

		}




		/*--------------------------------
		グラデーション
		--------------------------------*/
	
		const gradientFt = new Gradient({
			canvas: '#canvasFt',
			//colors: ['#a960ee', '#ff333d', '#90e0ff', '#ffcb57']
			colors: ['#ff8467', '#5f51bc', '#ff8467', '#5f51bc'],
		});
	}
	resizeCommon() {
		// 以前は function だったため this が window になり、this.h が更新されていなかった
		window.addEventListener('resize', (e) => {
			this.w = window.innerWidth;
			this.h = window.innerHeight;
			this.winScrollTop = window.scrollY;
		})
	}
	scrollCommon() {
		const footerBg = this.footer.querySelector('.bg');
		let ticking = false;

		// scroll イベントは 1 フレームに何度も来るので、描画は rAF で 1 回にまとめる
		const update = () => {
			ticking = false;

			/*--------------------------------
			header
			--------------------------------*/

			this.header.classList.toggle("active", this.winScrollTop > 500);

			/*--------------------------------
			footer
			--------------------------------*/
			const footerTop = this.footer.getBoundingClientRect().top;
			const footerH = this.footer.clientHeight;

			// 画面に入っていない間は clip-path を書き換えない
			if (footerTop > this.h) return;

			const start = this.h - footerTop;
			const percent = 100 - start / footerH * 100;

			footerBg.style.clipPath = 'inset(0 0 ' + percent + '% 0)';
		};

		document.addEventListener('scroll', () => {
			this.winScrollTop = window.scrollY;

			if (!ticking) {
				ticking = true;
				requestAnimationFrame(update);
			}
		}, { passive: true });
	}
}
